export const possibleTypes = {
  Actor: [
    'ResidentNode',
    'ApplicantNode',
    'ConciergeNode',
    'UserType',
    'TenancyApplicantNode',
  ],
  Target: [
    'CommunityUpdateNode',
    'ConversationNode',
    'CommunityNode',
    'ResidentSurveyNode',
    'ApplicationNode',
    'KeyNode',
    'CommunityProductNode',
    'AmenityNode',
    'TenantReferenceNode',
    'CommunityEventNode',
    'ConversationAssignmentNode',
    'TeamAssignmentNode',
    'UserType',
    'PackageNode',
    'CommunityDocumentNode',
    'UserDocumentNode',
    'ResidencyDocumentNode',
    'MarketplaceItemNode',
    'GroupChatNode',
    'MarketplaceItemThreadNode',
    'FeatureAnnouncementNode',
    'TaskNode',
    'ApplicationThreadNode',
    'DocumentExtractionNode',
  ],
  ActionObject: [
    'CommunityUpdateCommentNode',
    'CommunityUpdateLikeType',
    'ApplicationNode',
    'KeyholderNode',
    'CommunityProductPurchaseNode',
    'AmenityReservationNode',
    'GroupChatMessageNode',
    'MarketplaceItemCommentNode',
    'MarketplaceItemThreadMessageNode',
    'MarketplaceItemNode',
    'CommunityEventNode',
  ],
  TeamAssignmentContent: [
    'ConversationNode',
    'CommunityDocumentNode',
    'UserDocumentNode',
  ],
  RuleActionTargetUnion: ['TeamNode', 'UserType'],
  LandlordDocumentNode: [
    'GeneratedAgreementNode',
    'GeneratedSection21Node',
    'LandlordAttachmentNode',
  ],
};
